// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EwIL","content":"styles_content__SU4FQ"};